import {PostCommentError} from './PostCommentError.js'
import {RatingError} from './RatingError.js'
import {ReviewsError} from './ReviewsError.js'

export class ReviewsErrorsFactory extends ReviewsError {
  static getCommentsError = () => new ReviewsError()
  static postCommentsError = () => new PostCommentError()
  static ratingError = () => new RatingError()
}
